import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import LogInput from "../../../../../../../components/atoms/LogInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import CurrencyFormat from "react-currency-format";
import LogDateInput from "../../../../../../../components/atoms/LogDateInput";
import LogInputCurrency from "../../../../../../../components/atoms/LogInputCurrency";
import LogSelect from "../../../../../../../components/atoms/LogSelect";
import {
  getPaymentTypeAPI,
  postReceipt,
} from "../../../../../../../api/modules";
import LogButton from "../../../../../../../components/atoms/LogButton";
import {
  errorToast,
  successToast,
} from "../../../../../../../services/toastService";

const InvoiceSchema = Yup.object().shape({
  receipt_date: Yup.date()
    .required("Fecha de Recibo es obligatorio")
    .nullable(),
  receipt_method: Yup.string()
    .required("Metodo pago es obligatorio")
    .nullable(),
  receipt_number: Yup.string().required("Numero de recibo es obligatorio"),
  receipt_amount: Yup.number()
    .required("Monto es obligatorio")
    .positive("Monto debe ser mayor a cero")
    .test(
      "decimal-places",
      "Monto debe tener como máximo dos decimales",
      (value) =>
        value === undefined ||
        value === null ||
        /^\d+(\.\d{1,2})?$/.test(value.toString())
    ),
});

const SubmitReceipt = ({ data, refetch }) => {
  const [paymentTypeAPI, setPaymentTypeAPI] = useState([]);
  const getData = async () => {
    const respPaymentTypeAPI = await getPaymentTypeAPI();
    const { paymentType } = respPaymentTypeAPI;
    try {
      let paymentTypeFormatted = paymentType.map((l) => ({
        _id: l._id,
        label: l.payment_type_name,
        value: l._id,
      }));
      setPaymentTypeAPI(paymentTypeFormatted);
    } catch (error) {
      setPaymentTypeAPI([]);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    dirty,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      receipt_date: null,
      receipt_method: null,
      receipt_number: "",
      receipt_amount: "",
    },
    onSubmit: async (values) => {
      const resp = await postReceipt({
        ...values,
        invoice_id: data?.invoice_id?._id,
        id_tomador: data?.invoice_id?.id_tomador,
        id_dador: data?.invoice_id?.id_dador,
      });
      const { msg } = resp;
      if (msg) {
        errorToast(msg || "Intente Nuevamente");
        resetForm();
      } else {
        successToast(`Recibo cargado con exito`);
        resetForm();
      }
      refetch();
    },
    validationSchema: InvoiceSchema,
  });
  useEffect(() => {
    getData();
    return () => resetForm();
  }, []);

  const invoiceNumbers = [
    data?.invoice_id?.invoice_number,
    data?.invoice_id?.invoice_dador_comision_not_required
      ? "Comision no aplica"
      : data?.invoice_dador_comision?.number,
  ]
    .filter(Boolean)
    .join(" / ");

  return (
    <Container fluid style={{ maxWidth: 600 }}>
      <Row>
        <Col>
          <h1 className="h5 mt-3 mb-4 text-primary text-center font-weight-bold">
            {"Facturas nro.  " + invoiceNumbers}
          </h1>
        </Col>
      </Row>

      <Form.Group>
        <Row className="mb-3">
          <Col xs={3}>
            <label className="black-primary font-weight-bold mb-0 mt-2">
              Pago:
            </label>
          </Col>
          <Col xs={9}>
            <LogSelect
              name="receipt_method"
              placeholder="Forma de pago"
              items={paymentTypeAPI}
              onChange={(v) => {
                setFieldValue("receipt_method", v);
              }}
              onBlur={handleBlur.receipt_method}
              errors={errors}
              value={values.receipt_method}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={3}>
            <label className="black-primary font-weight-bold mb-0 mt-2">
              Fecha:
            </label>
          </Col>
          <Col xs={9}>
            <LogDateInput
              size="md"
              name="receipt_date"
              className="number-font p-0"
              placeholder="Fecha de Recibo"
              onBlur={handleBlur}
              errors={errors}
              value={values.receipt_date}
              onChange={(value) => {
                setFieldValue("receipt_date", value);
              }}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col xs={3}>
            <label className="black-primary font-weight-bold mb-0 mt-2">
              {"Numero:"}
            </label>{" "}
          </Col>
          <Col xs={9}>
            <LogInput
              name="receipt_number"
              className="p-0"
              placeholder="Numero de Recibo"
              onBlur={handleBlur.receipt_number}
              type="text"
              errors={errors}
              value={values.receipt_number}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={3}>
            <label className="black-primary font-weight-bold mb-0 mt-2">
              Monto:
            </label>
          </Col>
          <Col xs={9}>
            <LogInputCurrency
              className="number-font p-1"
              placeholder="AR$"
              type="text"
              name="receipt_amount"
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              prefix={"$ "}
              onValueChange={(values) => {
                const { value } = values;
                const number = value ? parseFloat(value) : "";
                setFieldValue("receipt_amount", number);
              }}
              onBlur={handleBlur}
              errors={errors}
              value={values.receipt_amount}
            />
          </Col>
        </Row>
        <Row className="mt-5">
          <Col className="d-flex justify-content-center">
            <LogButton
              disabled={!dirty || isSubmitting}
              className="w-50"
              color="primary"
              onClick={handleSubmit}
              title={isSubmitting ? "Cargando..." : "Cargar Recibo"}
              border="curve"
            />
          </Col>
        </Row>
      </Form.Group>
    </Container>
  );
};

export default SubmitReceipt;
